import {
    Box,
    Container,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Link as MuiLink,
    Card,
    CardContent
} from '@mui/material';
import {
    LocationOn,
    Email,
    Phone,
    WhatsApp,
    LinkedIn,
    YouTube,
    Facebook,
    Article,
    Instagram
} from '@mui/icons-material';

export const Contact = () => {
    const contactInfo = [
        {
            icon: <LocationOn />,
            label: "Address",
            value: "Meeraj Kanaparthi\nGachibowli, Hyderabad, Telangana, India 500032"
        },
        {
            icon: <Email />,
            label: "Email",
            value: "meeraj.kanaparthi@gmail.com"
        },
        {
            icon: <Phone />,
            label: "Phone",
            value: "+91 9885863330"
        },
        {
            icon: <WhatsApp />,
            label: "WhatsApp",
            value: "+91 9885863330"
        }
    ];

    const socialLinks = [
        {
            icon: <LinkedIn />,
            label: "LinkedIn",
            url: "https://www.linkedin.com/in/meeraj-k-69ba76189/"
        },
        {
            icon: <YouTube />,
            label: "YouTube",
            url: "https://www.youtube.com/channel/UCtcEuGgCTWzzXBGvwCKm5VA"
        },
        {
            icon: <Facebook />,
            label: "Facebook",
            url: "https://www.facebook.com/meeraj.k.35"
        },
        {
            icon: <Article />,
            label: "Medium",
            url: "https://kmeeraj.medium.com/"
        },
        {
            icon: <Instagram />,
            label: "Instagram",
            url: "https://www.instagram.com/meeraj.kanaparthi1/"
        }
    ];

    return (
        <Container maxWidth="lg">
            <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
                Contact
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3 }}>
                <Box sx={{ flex: 1 }}>
                    <Card elevation={2}>
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Contact Information
                            </Typography>
                            <List>
                                {contactInfo.map((item, index) => (
                                    <ListItem key={index}>
                                        <ListItemIcon>
                                            {item.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={item.label}
                                            secondary={item.value}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </CardContent>
                    </Card>
                </Box>
                
                <Box sx={{ flex: 1 }}>
                    <Card elevation={2}>
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Social Media
                            </Typography>
                            <List>
                                {socialLinks.map((item, index) => (
                                    <ListItem key={index}>
                                        <ListItemIcon>
                                            {item.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={
                                                <MuiLink href={item.url} target="_blank" rel="noopener">
                                                    {item.label}
                                                </MuiLink>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </CardContent>
                    </Card>
                </Box>
            </Box>
        </Container>
    )
}